import clsx from 'clsx'

import { Contract } from '../../models/Contract'
import { Type } from '../../models/Type'
import { Icon } from '../Icon'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'
import { WorkflowPageCard } from './WorkflowPageCard'

type Props = {
    form: Type | undefined
    contract: Contract | undefined
    onOpenForm?: () => void
    onOpenContract?: () => void
}

export const FormAndContractCard = ({ form, contract, onOpenForm, onOpenContract }: Props) => {
    if (!form && !contract) return null

    return (
        <WorkflowPageCard title={!contract ? 'Form' : !form ? 'Contract' : 'Form & Contract'}>
            <div className="flex flex-col items-stretch justify-center gap-y-3">
                {form !== undefined && form.name !== undefined && (
                    <FormAndContractView name={form.name} onClick={onOpenForm} />
                )}
                {contract !== undefined && contract.name !== undefined && (
                    <FormAndContractView name={contract.name} onClick={onOpenContract} />
                )}
            </div>
        </WorkflowPageCard>
    )
}

const FormAndContractView = ({ name, onClick }: { name: string; onClick?: () => void }) => {
    return (
        <button
            onClick={onClick}
            className={clsx(
                'flex items-center justify-center gap-x-4 rounded-lg border border-gray-300 bg-gray-100 px-4 py-3 text-left',
                !onClick ? 'cursor-default select-text' : 'hover:bg-gray-300'
            )}
        >
            <Icon
                icon="file.large"
                background="round"
                backgroundColorClassName="bg-gray-600"
                className="text-white"
                shouldInheritColor
            />
            <div className="shrink grow">
                <Label size="sm" className="mb-1 text-gray-700">
                    {name}
                </Label>
                <Paragraph size="sm" className="text-gray-600">
                    PDF
                </Paragraph>
            </div>
            {!!onClick && <Icon icon="chevronRight.medium" className="text-gray-600" />}
        </button>
    )
}
